export default "__VITE_ASSET__9W3htfTw__"